export const COLLABORATION_CATEGORY = {
  food: '푸드',
  beauty: '뷰티',
  fashion_accessory: '패션/악세사리',
  electronics: '가전/전자기기',
  home_living: '홈/리빙',
  pets: '반려동물',
  sports: '스포츠',
  travel: '여행',
  etc: '기타',
} as const;

export const COLLABORATION_TYPE = {
  group_buy: '공동 구매',
  ads: '광고',
  live: '라이브 방송',
  tiktok: '해외 틱톡샵',
  youtube: '해외 유튜브 쇼핑',
} as const;

// 협업 제안하기 airtable 협업 카테고리 키값
export const COLLABORATION_CATEGORIES = Object.values(
  COLLABORATION_CATEGORY,
) as readonly (typeof COLLABORATION_CATEGORY)[keyof typeof COLLABORATION_CATEGORY][];

// 협업 제안하기 airtable 제안 종류 키값
export const COLLABORATION_TYPES = Object.values(
  COLLABORATION_TYPE,
) as readonly (typeof COLLABORATION_TYPE)[keyof typeof COLLABORATION_TYPE][];
